

















import settings from '@/settings'
import mutations from '@/gql/mutations'
import queries from '@/gql/queries'

export default {
    name: "TextForNextReport"
    props:
        establishment: 
            default: null
    data: ()->
        text: null
        loading: false
    computed:
        reportsLink: ()->
            return settings.backendUrl + "/admin/establishment/establishmentreport/?establishment__uid__exact=" + @establishment.uid
    methods:
        getText: ()->
            self = @
            self.loading = true
            self.text = null
            queries.run("get_next_report_text", [self.establishment.uid])
            .then (resp)->
                self.loading = false
                if resp.body.data.establishment_report_set.length > 0
                    self.text = resp.body.data.establishment_report_set[0].custom_text
                self.$store.commit("delete_edited_fields", {
                    key: "TextForNextReport.text"
                })
            .catch ()-> 
                self.loading = false
        saveText: ()->
            self = @
            self.loading = true
            mutations.run("save_next_report_text", [
                self.establishment.uid,
                self.text.replace(/"/g,"'").replace(/\n/g,"\\n")])
            .then ()->
                self.loading = false
                self.$store.commit("delete_edited_fields", {
                    key: "TextForNextReport.text"
                })
                return
            .catch ()->
                self.loading = false
    mounted: ()->
        self = @
        self.getText()
    watch:
        'establishment.uid': (newV)->
            if newV
                this.getText()
        'text': (newV, oldV)->
            if oldV?
                @$store.commit("update_edited_fields", {
                    key: "TextForNextReport.text"
                    value: newV
                    verbose_name: "Texte pour le prochain rapport"
                    el: this.$refs.text
                })

        
                
}
